import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import {
  CreateMemberTagPayload,
  MemberTag,
  MemberTagWithCount,
  UpdateMemberTagPayload,
} from './model'

export const MemberTagService = (client: AxiosInstance) => {
  return {
    async listAll(): Promise<MemberTagWithCount[]> {
      const { data } = await wrapApiCall(() => client.get<MemberTagWithCount[]>('/member-tags'))
      return data ?? []
    },
    async create(payload: CreateMemberTagPayload): Promise<MemberTag> {
      const { data } = await wrapApiCall(() => client.post<MemberTag>('/member-tags', payload))
      return data
    },
    async update(id: number, payload: UpdateMemberTagPayload): Promise<MemberTag> {
      const { data } = await wrapApiCall(() =>
        client.patch<MemberTag>(`/member-tags/${id}`, payload)
      )
      return data
    },
    async delete(id: number): Promise<{ success: boolean }> {
      const { data } = await wrapApiCall(() =>
        client.delete<{ success: boolean }>(`/member-tags/${id}`)
      )
      return data
    },
    async listForMember(memberId: number | string): Promise<MemberTag[]> {
      const { data } = await wrapApiCall(() => client.get<MemberTag[]>(`/members/${memberId}/tags`))
      return data ?? []
    },
    async assignToMember(memberId: number | string, tagId: number): Promise<MemberTag[]> {
      const { data } = await wrapApiCall(() =>
        client.post<MemberTag[]>(`/members/${memberId}/tags`, { tagId })
      )
      return data ?? []
    },
    async unassignFromMember(memberId: number | string, tagId: number): Promise<MemberTag[]> {
      const { data } = await wrapApiCall(() =>
        client.delete<MemberTag[]>(`/members/${memberId}/tags/${tagId}`)
      )
      return data ?? []
    },
  }
}
